module.exports = __webpack_public_path__ + "Roboto-Regular.3cf6adf61054c328b1b0.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/roboto/Roboto-Regular.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Regular.woff
// module chunks = styles